import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import StrategyTreeView from '@app/views/ProjectStrategyTreeView/TreeView';
import { memo } from 'react';

export default memo(
  withIfUser(StrategyTreeView)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
